const l = {
  name: "Select",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M24,19.4L18.6,14l1.4-1.4l4,4l8-8l1.4,1.4L24,19.4z"/>
		<path class="st0" d="M17,0c-2.8,0-5,2.2-5,5v17.4L0,27.3v2.5l8.2,2l2,8.2h2.5l4.9-12H35c2.8,0,5-2.2,5-5V5c0-2.8-2.2-5-5-5H17z
			 M18.4,26l1.7-4.2l-1.9-1.9L14,21.6V5c0-1.7,1.3-3,3-3h18c1.7,0,3,1.3,3,3v18c0,1.7-1.3,3-3,3H18.4z M9.8,30.2l-7.1-1.8l15.1-6.2
			l0.1,0.1l-6.2,15.1L9.8,30.2z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Select
};
